var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColorswatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 9.25098H2.25C1.83579 9.25098 1.5 9.58676 1.5 10.001V14.001C1.5 14.4152 1.83579 14.751 2.25 14.751H15C15.4142 14.751 15.75 14.4152 15.75 14.001V10.001C15.75 9.58676 15.4142 9.25098 15 9.25098Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.499971 11.1705L0.307471 10.808C0.269645 10.717 0.250117 10.6194 0.250001 10.5209C0.249884 10.4224 0.269183 10.3248 0.306794 10.2337C0.344405 10.1427 0.39959 10.0599 0.469198 9.99017C0.538806 9.92043 0.621471 9.8651 0.712471 9.82733L12.4862 4.9342C12.6699 4.85801 12.8763 4.85787 13.0601 4.93381C13.2438 5.00976 13.3899 5.15557 13.4662 5.3392L14.5387 7.91983",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.40039 9.54122L9.46789 1.47059C9.53757 1.40067 9.62036 1.34519 9.71153 1.30734C9.80269 1.26949 9.90043 1.25 9.99914 1.25C10.0979 1.25 10.1956 1.26949 10.2868 1.30734C10.3779 1.34519 10.4607 1.40067 10.5304 1.47059L12.3123 3.25122",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10.501H5V13.501H14V10.501Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10.501V13.501",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 10.501V13.501",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25 12.251C3.38807 12.251 3.5 12.139 3.5 12.001C3.5 11.8629 3.38807 11.751 3.25 11.751C3.11193 11.751 3 11.8629 3 12.001C3 12.139 3.11193 12.251 3.25 12.251Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorswatch);
export default __webpack_public_path__ + "static/media/color swatch.6c4aaa25.svg";
export { ForwardRef as ReactComponent };